import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ContentReferenceCreateManyMutationVariables = Types.Exact<{
  contentReferences: Array<Types.ContentReferenceCreateInput> | Types.ContentReferenceCreateInput
  deleteOmittedReferences?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type ContentReferenceCreateManyMutation = {
  __typename?: 'Mutation'
  contentReferenceCreateMany: {
    __typename?: 'ContentReferenceCreateManyResponse'
    contentReferences?: Array<{
      __typename?: 'ContentReference'
      id?: string | null
      sortKey?: number | null
    } | null> | null
  }
}

export const ContentReferenceCreateManyDocument = gql`
  mutation ContentReferenceCreateMany(
    $contentReferences: [ContentReferenceCreateInput!]!
    $deleteOmittedReferences: Boolean = false
  ) {
    contentReferenceCreateMany(
      contentReferences: $contentReferences
      deleteOmittedReferences: $deleteOmittedReferences
    ) {
      contentReferences {
        id
        sortKey
      }
    }
  }
`
export type ContentReferenceCreateManyMutationFn = Apollo.MutationFunction<
  ContentReferenceCreateManyMutation,
  ContentReferenceCreateManyMutationVariables
>

/**
 * __useContentReferenceCreateManyMutation__
 *
 * To run a mutation, you first call `useContentReferenceCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentReferenceCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentReferenceCreateManyMutation, { data, loading, error }] = useContentReferenceCreateManyMutation({
 *   variables: {
 *      contentReferences: // value for 'contentReferences'
 *      deleteOmittedReferences: // value for 'deleteOmittedReferences'
 *   },
 * });
 */
export function useContentReferenceCreateManyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContentReferenceCreateManyMutation,
    ContentReferenceCreateManyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContentReferenceCreateManyMutation,
    ContentReferenceCreateManyMutationVariables
  >(ContentReferenceCreateManyDocument, options)
}
export type ContentReferenceCreateManyMutationHookResult = ReturnType<
  typeof useContentReferenceCreateManyMutation
>
export type ContentReferenceCreateManyMutationResult =
  Apollo.MutationResult<ContentReferenceCreateManyMutation>
export type ContentReferenceCreateManyMutationOptions = Apollo.BaseMutationOptions<
  ContentReferenceCreateManyMutation,
  ContentReferenceCreateManyMutationVariables
>
